export var formatDate = function (value) {
    var date = new Date(value);
    return date.toLocaleDateString('en-GB');
};
